import React from 'react';

import { Divider } from '@lyearn/ui';
import RichTextViewer from '@/components/RichTextViewer';

import { LessonDescriptionProps } from './types';

const LessonDescription: React.FC<LessonDescriptionProps> = (props) => {
  const { description, placeholder } = props;

  if (!description || description === placeholder) {
    return null;
  }

  return (
    <>
      <RichTextViewer
        className="mb-20 mt-24 me-32 xs:px-20 xs:me-0"
        color="text-text-placeholder"
        data-id="description"
        html={description}
        variant="body-long-01"
      />
      <Divider className="mb-40" />
    </>
  );
};

export default React.memo(LessonDescription);
